import { themes } from '@infotech-soe/erp-ui-kit';

export type ThemeName = keyof typeof themes;
export type ForbiddenThemeName = Extract<ThemeName, 'base'>;
export type AllowedThemeName = Exclude<ThemeName, ForbiddenThemeName>;

export const DEFAULT_THEME: AllowedThemeName = 'modern';
export const FORBIDDEN_THEMES = new Set<ForbiddenThemeName>(['base']);
